export interface AuditTrailCommentEntry {
  comment?: string | null;
  date?: string | null;
}

const STUDY_COMMENT_PREFIX = /^study\s+(saved|updated|committed)\s*:\s*/i;

function normalizeComment(raw: string | null | undefined): string {
  return (raw ?? '').trim();
}

export function stripStudyCommentPrefix(raw: string | null | undefined): string {
  const normalized = normalizeComment(raw);
  if (!normalized) {
    return '';
  }
  return normalized.replace(STUDY_COMMENT_PREFIX, '').trim();
}

export function getLatestAuditTrailComment(
  auditTrail: AuditTrailCommentEntry[] | null | undefined
): string {
  const entries = auditTrail ?? [];
  type Candidate = { text: string; timestamp: number | null; index: number };
  let best: Candidate | null = null;

  for (let index = 0; index < entries.length; index += 1) {
    const entry = entries[index];
    const stripped = stripStudyCommentPrefix(entry?.comment);
    if (!stripped) {
      continue;
    }

    const parsed = entry?.date ? Date.parse(entry.date) : Number.NaN;
    const timestamp = Number.isFinite(parsed) ? parsed : null;
    const candidate: Candidate = { text: stripped, timestamp, index };

    if (!best) {
      best = candidate;
      continue;
    }

    if (candidate.timestamp !== null && best.timestamp !== null) {
      if (candidate.timestamp > best.timestamp) {
        best = candidate;
      } else if (candidate.timestamp === best.timestamp && candidate.index > best.index) {
        best = candidate;
      }
      continue;
    }

    if (candidate.timestamp !== null && best.timestamp === null) {
      best = candidate;
      continue;
    }

    if (candidate.timestamp === null && best.timestamp === null && candidate.index > best.index) {
      best = candidate;
    }
  }

  return best?.text ?? '';
}
